// context/AuthContext.jsx

import React, { createContext, useContext, useEffect, useState } from "react";
import { BASE_URL } from "../config/apiconfig";

const AuthContext = createContext();
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);
  const [token, setToken] = useState(localStorage.getItem("token") || null);
  const [adminId, setAdminId] = useState(
    localStorage.getItem("admin_id") || null
  );
  const [isReady, setIsReady] = useState(false);

  // Rehydrate once
  useEffect(() => {
    const t = localStorage.getItem("token");
    const a = localStorage.getItem("admin_id");

    if (t) setToken(t);
    if (a) setAdminId(a);

    setIsReady(true);
  }, []);

  const login = async (email, password) => {
    try {
      const response = await fetch(`${BASE_URL}/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email,
          password,
        }),
      });

      const data = await response.json();

      if (data.status === 200) {
        const user = data.data;

        // persist
        localStorage.setItem("token", user.token);
        localStorage.setItem("admin_id", user.uid);

        if (user.role) {
          localStorage.setItem("role", user.role.toLowerCase());
        }

        if (user.permissions) {
          localStorage.setItem(
            "permissions",
            JSON.stringify(user.permissions)
          );
        }

        // state
        setAdmin(user);
        setToken(user.token);
        setAdminId(user.uid);

        return {
          success: true,
          message: data.message,
        };
      }

      return {
        success: false,
        message: data?.message || "Login failed",
      };
    } catch (err) {
      return {
        success: false,
        message: "Login failed",
      };
    }
  };

  const forgotPassword = async (email) => {
    try {
      const response = await fetch(`${BASE_URL}/forgot-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (response.status === 200) {
        console.log("FORGOT API RESPONSE:", data);

        const resetToken = data.token || data.reset_token;

        if (resetToken) {
          localStorage.setItem("reset_token", resetToken);
        } else {
          console.error("Token not found in response");
        }

        return {
          success: true,
          message: data.message,
        };
      }

      return {
        success: false,
        message: data?.message,
      };
    } catch (err) {
      return {
        success: false,
        message: "Forgot password failed",
      };
    }
  };

  const validateOtp = async (email, otp) => {
    try {
      const resetToken = localStorage.getItem("reset_token");

      const response = await fetch(`${BASE_URL}/validate-otp`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...(token && {
            Authorization: `Bearer ${token}`,
          }),
        },
        body: JSON.stringify({
          email,
          otp,
          token: resetToken,
        }),
      });

      const data = await response.json();

      if (response.status === 200 || data.status === 200) {
        return {
          success: true,
          message: data.message,
        };
      }

      return {
        success: false,
        message: data?.message,
      };
    } catch (err) {
      return {
        success: false,
        message: "OTP validation failed",
      };
    }
  };

  const resetPassword = async (email, newPassword) => {
    try {
      const resetToken = localStorage.getItem("reset_token");

      if (!resetToken) {
        return {
          success: false,
          message: "Session expired. Please try again.",
        };
      }

      const response = await fetch(`${BASE_URL}/reset-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...(token && {
            Authorization: `Bearer ${token}`,
          }),
        },
        body: JSON.stringify({
          email,
          token: resetToken,
          password: newPassword,
        }),
      });

      const data = await response.json();

      if (data.status === 200) {
        return {
          success: true,
          message: data.message,
        };
      }

      return {
        success: false,
        message: data?.message || "Reset failed",
      };
    } catch (err) {
      return {
        success: false,
        message: "Reset password failed",
      };
    }
  };

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("admin_id");
    localStorage.removeItem("role");
    localStorage.removeItem("permissions");
    localStorage.removeItem("reset_token");

    setAdmin(null);
    setToken(null);
    setAdminId(null);
  };

  return (
    <AuthContext.Provider
      value={{
        admin,
        adminId,
        token,
        isReady,
        login,
        logout,
        forgotPassword,
        validateOtp,
        resetPassword,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};